(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('wsPeopleGroupsList', ['$http', '$q', '$rootScope', 'Api', 'Demo', 'GroupUtils', 'screenSize', 'User', 'Utils', function wsPeopleGroupsList($http, $q, $rootScope, Api, Demo, GroupUtils, screenSize, User, Utils) {
    return {
      restrict: "EA",
      scope: {
        onSelect: "=",
        searchFilter: "=?",
        showMembership: "=?",
        hidePeople: "=?",
        hideGroups: "=?",
        excludeEntities: "=?",
        expandedPermissionsIfAllowed: '=?',
        referenceType: "<",
        referenceId: "<"
      },
      templateUrl: "modules/common/directives/people-and-groups-list/people-and-groups-list.html",
      controller: function controller($scope, $http, $routeParams, $timeout, $location, $q) {
        $scope.activeTab = $routeParams.activeTab || 'peopleTab';
        $scope.activeTabName = $scope.activeTab;
        $scope.datastate = {
          loaded: false
        };
        $scope.expandedPermissionsIfAllowed = !!$scope.expandedPermissionsIfAllowed;

        //this is wrapped in a timeout so it doesn't catch the tabset being initialized
        $timeout(function () {
          $scope.tabSelected = function (value) {
            $location.search('activeTab', Utils.toCamelCase(value));
          };
          if ($scope.hidePeople && $scope.groupTypes) {
            $scope.activeTabName = $scope.groupTypes[0].name;
            $scope.tabSelected($scope.groupTypes[0].name);
          }
        });
        if ($scope.excludeEntities && $scope.excludeEntities.length > 0) {
          // Sort them into people and groups
          $scope.excludedPeopleIds = _.chain(_.flatten($scope.excludeEntities)).filter(function (e) {
            return e.personas;
          }).map(function (p) {
            return p.id;
          }).value();
          $scope.excludedGroupIds = _.chain(_.flatten($scope.excludeEntities)).filter(function (e) {
            return !e.personas;
          }).map(function (g) {
            return g.id;
          }).value();
          if (!$scope.excludedPeopleIds.length) {
            $scope.excludedPeopleIds = null;
          }
          if (!$scope.excludedGroupIds.length) {
            $scope.excludedGroupIds = null;
          }
        }

        // We'll hide the group tabs, but don't spend any time fetching the group types
        if ($scope.hideGroups) {
          $scope.groupTypes = [];
        } else {
          if ($scope.searchFilter) {
            var params = {
              query: $scope.searchFilter,
              hideGroups: !$scope.referenceType
            };
            if ($scope.hidePeople) {
              params.hidePeople = $scope.hidePeople;
            }
            if ($scope.excludedPeopleIds) {
              params.excludedPeople = $scope.excludedPeopleIds;
            }
            if ($scope.excludedGroupIds) {
              params.excludedGroups = $scope.excludedGroupIds;
            }
            if ($scope.expandedPermissionsIfAllowed) {
              params.expandedPermissionsIfAllowed = true;
            }
            if ($scope.referenceType) {
              params[$scope.referenceType] = $scope.referenceId;
            }
            $http.get(Api.url("/search/people-and-groups"), {
              params: params
            }).then(function (response) {
              $scope.groupTypes = _.chain(response.data.groupTypes.results).filter(function (g) {
                return g.id >= 0;
              }).sortBy(function (g) {
                return g.displayOrder || g.name;
              }).value();
              if (!response.data.people || response.data.people.results.length === 0) {
                $timeout(function () {
                  $scope.hidePeople = true;
                  $scope.activeTabName = $scope.groupTypes[0].name;
                  $scope.tabSelected($scope.groupTypes[0].name);
                });
              }

              //determine which tab should be active (adding 'tab' to our hardcoded groups, in case org uses same group names)
              angular.forEach($scope.groupTypes, function (groupType) {
                if ($scope.activeTab === Utils.toCamelCase(groupType.name)) {
                  $scope.activeTabName = groupType.name;
                }
              });
            });
          } else {
            // Show all (the old way)
            var _params = {
              params: {
                type: "",
                "_limit": 1,
                "sparse": true
              }
            };
            _params.referenceType = $scope.referenceId;
            var requests = [$http.get(Api.url("/group-types"), {
              params: {
                _limit: 150
              }
            }), $http.get(Api.url("/groups"), _params)];
            $q.all(requests).then(function (responses) {
              var emptyGroupTypeName = "Group";
              $scope.groupTypes = _.sortBy(_.filter(responses[0].data.results, function (g) {
                return g.id >= 0;
              }), function (g) {
                return g.displayOrder || g.name;
              });
              //create additional tab if there are groups with no Group Type, with new property emptyType = true
              if (responses[1].data.results.length > 0) {
                $scope.emptyGroupType = {
                  "name": emptyGroupTypeName,
                  "emptyType": true
                };
              }

              //determine which tab should be active (adding 'tab' to our hardcoded groups, in case org uses same group names)
              angular.forEach($scope.groupTypes, function (groupType) {
                if ($scope.activeTab === Utils.toCamelCase(groupType.name)) {
                  $scope.activeTabName = groupType.name;
                }
              });
            });
          }
        }
      }
    };
  }]).controller('PeopleListCtrl', ['$controller', '$filter', '$scope', 'Api', function ($controller, $filter, $scope, Api) {
    $scope.defaultSortBy = "name";
    $scope.sortControls = [{
      "title": "Name",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      },
      "colspan": 2
    }, {
      "title": "Emails & Accounts",
      "class": "col-md-4 hidden-xs"
    }];
    if ($scope.showMembership) {
      $scope.sortControls.push({
        "title": "Watershed User?",
        "class": "col-md-2 hidden-xs"
      });
    }
    $scope.processFetchResponse = function (response) {
      var data = response.data.people ? response.data.people : response.data;
      data.results = _.reject(data.results, function (p) {
        return p.membership && _.contains(p.membership.user.roles, "watershed-employee") || _.findWhere($scope.excludeEntities, {
          id: p.id
        });
      });
      _.forEach(data.results, function (p) {
        p.personas = _.flatten(_.toArray(_.groupBy(_.sortBy(p.personas, function (p) {
          return $filter('personaDisplay')(p);
        }), function (p) {
          return p.account ? 1 : p.mbox ? 2 : 3;
        })));
      });
      $scope.datastate.loaded = true;
      return data;
    };
    $scope.showPersonaIdentifiers = true;
    var peopleUrl = $scope.showMembership ? "/people/reports/people-with-memberships" : "/search/people-and-groups";
    $scope.getApiUrl = Api.url(peopleUrl);
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    var fetchData = $scope.fetchData; // extend the fetchData supplied by ListerBaseCtrl

    var searchParam = {};
    if ($scope.searchFilter) {
      searchParam.query = $scope.searchFilter;
      searchParam.hideGroups = true;
      searchParam.hideGroupTypes = true;
    }
    if ($scope.excludedPeopleIds) {
      searchParam.excludedPeople = $scope.excludedPeopleIds;
    }
    if ($scope.excludedGroupIds) {
      searchParam.excludedGroups = $scope.excludedGroupIds;
    }
    if ($scope.expandedPermissionsIfAllowed) {
      searchParam.expandedPermissionsIfAllowed = true;
    }
    if ($scope.referenceType) {
      searchParam[$scope.referenceType] = $scope.referenceId;
    }
    $scope.fetchData = function (params) {
      _.extend(params, searchParam); // search only within the current groupType
      return fetchData(params);
    };
  }]).controller('GroupsListCtrl', ['$controller', '$scope', 'Api', function ($controller, $scope, Api) {
    $scope.defaultSortBy = "name";
    $scope.sortControls = [{
      "title": "Name",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      },
      "colspan": 2
    }];
    if ($scope.searchFilter) {
      $scope.getApiUrl = Api.url("/search/people-and-groups");
    } else {
      $scope.getApiUrl = Api.url("/groups");
    }
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    var fetchData = $scope.fetchData; // extend the fetchData supplied by ListerBaseCtrl

    var searchParam = $scope.groupType.emptyType ? {
      type: ""
    } : {
      "type.name": $scope.groupType.name
    };
    searchParam.sparse = true;
    if ($scope.searchFilter) {
      searchParam.query = $scope.searchFilter;
      searchParam.hideGroupTypes = true;
      searchParam.hidePeople = true;
    }
    if ($scope.excludedPeopleIds) {
      searchParam.excludedPeople = $scope.excludedPeopleIds;
    }
    if ($scope.excludedGroupIds) {
      searchParam.excludedGroups = $scope.excludedGroupIds;
    }
    if ($scope.expandedPermissionsIfAllowed) {
      searchParam.expandedPermissionsIfAllowed = true;
    }
    if ($scope.referenceType) {
      searchParam[$scope.referenceType] = $scope.referenceId;
    }
    $scope.fetchData = function (params) {
      _.extend(params, searchParam); // search only within the current groupType
      return fetchData(params);
    };
    $scope.processFetchResponse = function (response) {
      var data = response.data.groups ? response.data.groups : response.data;
      data.results = _.reject(data.results, function (group) {
        return _.findWhere($scope.excludeEntities, {
          id: group.id
        });
      });
      $scope.datastate.loaded = true;
      return data;
    };
  }]);
})();
